define.alias("ember-power-select/helpers/ember-power-select-is-selected-present", "media/helpers/ember-power-select-is-selected-present");